import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Badge"], _mergeProps(_ctx.$attrs, {
        state: $props.state,
        variant: $props.variant,
        size: $props.size,
        "data-static-id": $props.staticId ?? undefined,
        class: $setup.cn($setup.props.class)
    }), {
        default: _withCtx(() => [
            ($setup.showDot)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["badge-dot", $setup.badgeDotClasses[$props.state ?? 'default']])
                }, null, 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
            _renderSlot(_ctx.$slots, "prepend", {}, undefined, true),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            _renderSlot(_ctx.$slots, "append", {}, undefined, true)
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["state", "variant", "size", "data-static-id", "class"]));
}
